import React from "react";
import { useTranslation } from "react-i18next";
import Box from "react-raster";
import { Heading } from "src/components";
import { FileType } from "src/types";
import { theme } from "src/config";

export interface IFilesProps {
  fileType: FileType;
}

export const FileSection = (props: IFilesProps): JSX.Element => {
    const { t, i18n } = useTranslation();
    return (
      <Box>
        <Heading weight="normal" type="h3" color="black">Files</Heading>
        <Box><hr/></Box>
        <Box gridRowGap={theme.layout.gutter} maxWidth='50rem'>
        </Box>
      </Box>
    );
  }
